import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup } from "reactstrap";
import { Redirect } from "react-router-dom";
import "./FleetManager.css";
import FleetManagerService from "../../services/FleetManagerService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import HODashboardService from "../../services/HODashaboardService";
import { downlodFile } from "../../utils/utils";

class IndirectBillingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToIndirectBillingMonthWise: false,
      indirectBillingData: [],
      qMonth: "",
      isLoading: false,
      yearOptions: [],
      year: null,
      year_name_value: {}
    };
  }

  // componentWillMount() {
  //   this.getIndirectBillingReport();
  // }

  getIndirectBillingReport = async (year, download_report) => {
    let { indirectBillingData, isLoading } = this.state;

    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await FleetManagerService.getIndirectBillingReport(year, download_report);

      if(download_report) {
        if (data.data && data.data && data.data.file) {
          downlodFile(data.data.file);
        }
      } else {
        if (data && data.data) {
          indirectBillingData = data.data;
          (indirectBillingData || []).reverse();
        }
      }

      isLoading = false;
      this.setState({ indirectBillingData, isLoading });
    } catch (error) {
      console.log(error);
      isLoading = false;
      this.setState({ isLoading });
    }
  };

  goToIndirectBillingMonthWise = item => {
    let { redirectToIndirectBillingMonthWise, qMonth } = this.state;
    redirectToIndirectBillingMonthWise = true;
    qMonth = {
      id: window.btoa(item.month_id),
      month: window.btoa(item.month)
    };
    this.setState({ redirectToIndirectBillingMonthWise, qMonth });
  };

  componentDidMount = () => {
    this.filterAPI();
  };

  filterAPI = () => {
    const { year } = this.state;

    let filter = {
      y: year ? year : null
    };
    this.setState({ isLoader: true });
    HODashboardService.filterAPI(filter)
      .then(res => {
        if (res.data.data) {
          this.setState({ isLoader: false });

          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : []
            },
            () => {
              if (
                !this.state.year &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                this.setState(
                  {
                    year: this.state.yearOptions[0].value,
                    year_name_value: this.state.yearOptions[0]
                  },
                  () => {
                    this.getIndirectBillingReport(
                      this.state.year ? this.state.year : null, false
                    );
                  }
                );
              }
              //  else {
              //   this.getIndirectBillingReport(
              //     this.state.year ? this.state.year : null
              //   );
              // }
            }
          );
        }
      })
      .catch(err => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  onChangeYear = e => {
    this.setState(
      {
        year: e && e.target && e.target.value
      },
      () => {
        // this.filterAPI();
        let { yearOptions, year_name_value, year } = this.state;
        if (year) {
          year_name_value = yearOptions.filter(x => x.value == year);
        }
        if (year_name_value) {
          year_name_value =
            year_name_value && year_name_value[0]
              ? year_name_value[0]
              : year_name_value;
          this.setState({ year_name_value });
        }
        this.getIndirectBillingReport(this.state.year ? this.state.year : null, false);
      }
    );
  };

  render() {
    const {
      indirectBillingData,
      redirectToIndirectBillingMonthWise,
      qMonth,
      isLoading
    } = this.state;
    return (
      <div>
        {redirectToIndirectBillingMonthWise && (
          <Redirect
            to={{
              pathname: "/indirectBillingReportMonthWise",
              search: `id=${qMonth.id}&month=${qMonth.month}&yearname=${this.state.year_name_value.name}&year=${this.state.year}`
            }}
          />
        )}

        {isLoading && <CustomSpinner />}
        <Row
          style={{
            marginBottom: this.state.yearOptions.length > 1 ? "-17px" : "5px",
            marginTop: "-10px"
          }}
        >
          <Col xl="7" md="6" xs="12">
            <div>
              <span
                className="Offtake-Entry---Invo"
                style={{ fontSize: "22px" }}
              >
                Indirect Billing Report
              </span>
            </div>
          </Col>
          {this.state.yearOptions.length > 1 && (
            <Col xl="2" md="6" xs="12">
              <FormGroup>
                <select
                  name="month"
                  className="form-control cursor-pointer"
                  value={this.state.year}
                  style={{
                    fontSize: "13px",
                    width: "110px",
                    color: "#6e777f",
                    marginLeft: "auto"
                  }}
                  onChange={e => {
                    this.onChangeYear(e);
                  }}
                >
                  {this.state.yearOptions.map(item => (
                    <option value={item.value} selected>
                      {item.name}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </Col>
          )}
        </Row>

        <Row style={{
            marginBottom: "10px",
            marginTop: "10px"
          }}>
          <Col xl="7" md="6" xs="12">
            <div className="showingText">
              Financial Year{" "}
              {this.state.year_name_value && this.state.year_name_value.name}.
            </div>
          </Col>
          <Col xl="2" md="6" xs="12">
            <div className="custom-link" style={{
                    fontSize: "13px",
                    width: "110px",
                    marginLeft: "auto"
                  }} onClick={e =>
                    this.getIndirectBillingReport(this.state.year ? this.state.year : null, true)
                  }>
              Download Report
            </div>
          </Col>
        </Row>
        
        <Row>
          <Col xl="9" md="9" xs="12" sm="12">
            <Card>
              <CardBody>
                <table className="table table-bordered table-responsive">
                  <thead
                    id="billing-table-head"
                    className="offtake-check-table-head text-align-center"
                  >
                    <tr>
                      <th>Month</th>
                      <th>Total Invoice</th>
                      <th>Pending</th>
                      <th>Pending ZFM</th>
                      <th>Approved</th>
                      <th>Rejected</th>
                      <th>Approved / Total TBB</th>
                      <th>Approved / Total TBR</th>
                      <th>Approved / Total<br/>(TBB + TBR)</th>
                    </tr>
                  </thead>
                  <tbody id="billing-table-body">
                    {(indirectBillingData || []).map(item => {
                      return (
                        <tr key={item.month}>
                          <td>
                            <span
                              onClick={e =>
                                this.goToIndirectBillingMonthWise(item)
                              }
                              className="custom-link"
                            >
                              {item.month}
                            </span>
                          </td>
                          <td>{item.total}</td>
                          <td>{item.pending}</td>
                          <td>{item.pending_zfm}</td>
                          <td>{item.approved}</td>
                          <td>{item.rejected}</td>
                          <td>{item.approved_tbb} / {item.tbb}</td>
                          <td>{item.approved_tbr} / {item.tbr}</td>
                          <td>{item.approved_total_tbb_tbr} / {item.total_tbb_tbr}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default IndirectBillingReport;
